/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './index.styl';

const Loader = ({ white, ...other }) => (
  <div styleName="root" {...other}>
    <div
      styleName={classNames('spinner', {
        'spinner--white': white,
      })}
    />
  </div>
);

Loader.propTypes = {
  white: PropTypes.bool,
  className: PropTypes.string,
};

export default CSSModules(Loader, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Loader/index.jsx